import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'dynamicRangeSystem';

export class DynamicRangeSystem extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
